import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/** A to Z by project name by default, like the old project list's `{ ProjectName: 1 }` sort. */
export const DEFAULT_PROJECTS_ORDER: OrderBy[] = [{ field: 'ProjectName', direction: 'ASC' }];

export const buildGetProjectsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_PROJECTS_ORDER
) => `
  query {
    Projects: getProjects(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationId
        Tags
        ProjectName
        Leads
        Members
        LeadNames
        MemberNames
      }
    }
  }
`;

// Lightweight employee lookup for the Leads/Members combobox — once
// hr-directory (Phase 2) exists as the canonical employee-directory module,
// consider whether this query should move there instead of being owned here.
/** Newest employee first, like the old project dialog's employee search (`CreateDate`, descending). */
export const buildGetEmployeesQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    Employees: getUserProfileDetails(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral([{ field: 'CreatedDate', direction: 'DESC' }])}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        DisplayName
        Email
      }
    }
  }
`;
